




























































































































































































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { bus } from "../../main";
import * as user from "../../_store/user.module";
import { ReportVisiteInfo } from "../../_models/reportVisiteInfo";
// import { userInfo } from "os";

@Component
export default class ReportVisitaCreate extends Vue {
  @Prop() idRichiesta!: number;
  @Prop() activityType!: string;
  @Prop() infoTirocinio!: any;

  private tipiVisita: any;

  private denominazioneAzienda: string;
  private tirocinante: string;
  private tutorAziendale: string;
  private dataInizio: string;
  private dataFine: string;
  private orarioInizioMattina: string;
  private orarioFineMattina: string;
  private orarioInizioPomeriggio: string;
  private orarioFinePomeriggio: string;
  private attivitaTirocinio: string;
  private attivitaSvoltaTirocinante: string;
  private presenzaStagista: boolean;
  private colloquioStagista: boolean;
  private note: string;
  private attivitaCoerente: string;
  private motivazioneNonCoerenza: string;
  private firmaTutorFormativo: string;
  private tipoVisita: string;

  private dateMenu: boolean;
  private timeMenu: boolean;
  private dataVisita: string;
  private oraVisita: string;

  private personaleContattato: string;
  private personaleContattatoAltro: string;
  private periodo: string;
  private orarioTirocinio: string;
  private dataReport: string;
  private oraReport: string;
  private dateTemp: any;

  private dataVisitaRules: [boolean | string];
  private oraVisitaRules: [boolean | string];
  private personaleContattatoAltroRules: [boolean | string];
  private attivitaSvoltaTirocinanteRules: [boolean | string];
  private attivitaCoerenteRules: [boolean | string];
  private tipoVisitaRules: [boolean | string];
  private noteRules: [boolean | string];

  constructor() {
    super();
    this.tipiVisita = [
      "Telefonicamente",
      "In azienda",
      "In cantiere",
      "Via Email",
      "In Videochiamata"
    ];
    this.dateMenu = false;
    this.timeMenu = false;
    this.dataVisita = new Date().toISOString().substr(0, 10);
    this.denominazioneAzienda = this.infoTirocinio.denominazioneAzienda;
    this.tirocinante = this.infoTirocinio.allievo;
    this.tutorAziendale = this.infoTirocinio.tutorAzienda;
    this.dataInizio = this.infoTirocinio.dataInizioPeriodo;
    this.dataFine = this.infoTirocinio.dataFinePeriodo;
    this.orarioInizioMattina = this.infoTirocinio.orarioInizioMattino;
    this.orarioFineMattina = this.infoTirocinio.orarioFineMattino;
    this.orarioInizioPomeriggio = this.infoTirocinio.orarioInizioPomeriggio;
    this.orarioFinePomeriggio = this.infoTirocinio.orarioFinePomeriggio;
    this.attivitaTirocinio = this.infoTirocinio.attivitàTirocinio;
    this.attivitaSvoltaTirocinante = "";
    this.presenzaStagista = false;
    this.colloquioStagista = false;
    this.note = "";
    this.attivitaCoerente = "";
    this.motivazioneNonCoerenza = "";
    this.firmaTutorFormativo = "";

    this.periodo = this.dataInizio + " - " + this.dataFine;

    this.dataVisita = "";
    this.oraVisita = "";
    this.dataReport = "";
    this.oraReport = "";
    this.personaleContattato = "3";
    this.personaleContattatoAltro = "";
    this.orarioTirocinio =
      this.orarioInizioMattina +
      " - " +
      this.orarioFineMattina +
      " / " +
      this.orarioInizioPomeriggio +
      " - " +
      this.orarioFinePomeriggio;
    this.tipoVisita = "";
    this.dateTemp = null;

    this.dataVisitaRules = [true];
    this.oraVisitaRules = [true];
    this.personaleContattatoAltroRules = [true];
    this.attivitaSvoltaTirocinanteRules = [true];
    this.attivitaCoerenteRules = [true];
    this.tipoVisitaRules = [true];
    this.noteRules = [true];
  }

  @Watch("dateTemp")
  onDateTempChange() {
    this.dateFilter();
  }

  dateFilter() {
    const date = new Date(this.dateTemp);
    if (this.dateTemp !== null) {
      this.dataVisita = date.toLocaleString(["it-IT"], {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
      });
    } else {
      this.dataVisita = "";
    }
    this.validazioneDataVisita()
  }

  validazioneDataVisita() {
    var dataInizioL = this.parseDate(this.dataInizio)
    var dataFineL = this.parseDate(this.dataFine)
    var dataVisitaL = this.parseDate(this.dataVisita)
    if((dataVisitaL <= dataFineL) && (dataVisitaL >= dataInizioL)){
      if (this.dataVisita !== "") {
        this.dataVisitaRules = [true];
      } else {
        this.dataVisitaRules = ["Data visita necessaria"];
      }
    }else{
        this.dataVisitaRules = ["Data visita esterna al periodo del tirocinio"]
      }
  }

  validazioneOraVisita() {
    if (this.oraVisita !== "") {
      this.oraVisitaRules = [true];
    } else {
      this.oraVisitaRules = ["Ora visita necessaria"];
    }
  }

  validazionePersonaleContattato() {
    if (this.personaleContattato === "2") {
      if (this.personaleContattatoAltro !== "") {
        this.personaleContattatoAltroRules = [true];
      } else {
        this.personaleContattatoAltroRules = [
          "Inserire il personale contattato"
        ];
      }
    } else {
      this.personaleContattatoAltroRules = [true];
    }
  }

  validazioneAttivitaSvoltaTirocinante() {
    if (this.presenzaStagista === true) {
      if (this.attivitaSvoltaTirocinante !== "") {
        this.attivitaSvoltaTirocinanteRules = [true];
      } else {
        this.attivitaSvoltaTirocinanteRules = [
          "Inserire l'attività svolta dal tirocinante al momento del monitoraggio"
        ];
      }
    }
  }

  validazioneAttivitaCoerente() {
    if (this.attivitaCoerente === "0") {
      if (this.motivazioneNonCoerenza !== "") {
        this.attivitaCoerenteRules = [true];
      } else {
        this.attivitaCoerenteRules = ["Inserire motivo non coerenza attività"];
      }
    }
  }

  validazioneTipoVisita() {
    if (this.tipoVisita !== "") {
      this.tipoVisitaRules = [true];
    } else {
      this.tipoVisitaRules = ["Specificare il tipo di monitoraggio effettuato"];
    }
  }

  validazioneNote() {
    var valid: boolean = false;
    if (this.note === "" || this.note === null) {
      this.noteRules = [true];
    } else {
      valid = /^[0-9a-zA-Zìèéùòà';:,.\x20]{2,250}$/.test(this.note);
      if (valid) {
        this.noteRules = [true];
      } else {
        this.noteRules = [
          "Note non possono avere più di 250 caratteri e non deve contenere caratteri speciali e invii"
        ];
      }
    }
  }

  parseDate(date: string): Date {
    var tmpStr = "";
    var strArray = [];
    var finalDate = "";
    strArray = date.split("/");
    tmpStr = this.normalize(strArray[2]) + "-" + this.normalize(strArray[1]) + "-" + this.normalize(strArray[0]);
    var tmpDate = new Date(tmpStr);
    return tmpDate;
  }

  normalize(val: string): number{
    return +val
  }

  clearTutorSignature() {
    //@ts-ignore
    this.$refs.tutorSignaturePad.clearSignature();
  }

  async executeTest() {
    this.validazioneDataVisita();
    this.validazioneOraVisita();
    this.validazionePersonaleContattato();
    this.validazioneAttivitaSvoltaTirocinante();
    this.validazioneAttivitaCoerente();
    this.validazioneTipoVisita();
    this.validazioneNote();
  }

  close() {
    this.dateMenu = false;
    this.timeMenu = false;
    this.dataVisita = new Date().toISOString().substr(0, 10);
    this.denominazioneAzienda = this.infoTirocinio.denominazioneAzienda;
    this.tirocinante = this.infoTirocinio.allievo;
    this.tutorAziendale = this.infoTirocinio.tutorAzienda;
    this.dataInizio = this.infoTirocinio.dataInizioPeriodo;
    this.dataFine = this.infoTirocinio.dataFinePeriodo;
    this.orarioInizioMattina = this.infoTirocinio.orarioInizioMattino;
    this.orarioFineMattina = this.infoTirocinio.orarioFineMattino;
    this.orarioInizioPomeriggio = this.infoTirocinio.orarioInizioPomeriggio;
    this.orarioFinePomeriggio = this.infoTirocinio.orarioFinePomeriggio;
    this.attivitaTirocinio = this.infoTirocinio.attivitàTirocinio;
    this.attivitaSvoltaTirocinante = "";
    this.presenzaStagista = false;
    this.colloquioStagista = false;
    this.note = "";
    this.attivitaCoerente = "";
    this.motivazioneNonCoerenza = "";
    this.firmaTutorFormativo = "";

    this.periodo = this.dataInizio + " - " + this.dataFine;
    this.tipoVisita = "";
    this.dateTemp = null;

    this.dataVisita = "";
    this.oraVisita = "";
    this.dataReport = "";
    this.oraReport = "";
    this.personaleContattato = "3";
    this.personaleContattatoAltro = "";
    this.orarioTirocinio =
      this.orarioInizioMattina +
      " - " +
      this.orarioFineMattina +
      " / " +
      this.orarioInizioPomeriggio +
      " - " +
      this.orarioFinePomeriggio;

    this.dataVisitaRules = [true];
    this.oraVisitaRules = [true];
    this.personaleContattatoAltroRules = [true];
    this.attivitaSvoltaTirocinanteRules = [true];
    this.attivitaCoerenteRules = [true];
    this.tipoVisitaRules = [true];
    this.noteRules = [true];
    bus.$emit("closeCreateDialog");
  }

  create() {
    this.executeTest().then(() => {
      if ((this.$refs.form as Vue & { validate: () => boolean }).validate()) {
        //@ts-ignore
        const signatureTutor = this.$refs.tutorSignaturePad.saveSignature();
        var flagError: boolean = false;
        var coerenza: boolean = false;
        var persContattatoString: string = "";
        var tutorFormInfo = user.readUserInfo(this["$store"]);

        switch (this.personaleContattato) {
          case "1":
            persContattatoString = "Tutor Aziendale: " + this.tutorAziendale;
            break;

          case "2":
            persContattatoString = this.personaleContattatoAltro;
            break;

          case "3":
            persContattatoString = "Nessuna persona informata sullo stage";
            break;
        }

        if (signatureTutor.isEmpty === false) {
          if (
            this.personaleContattato !== "3" &&
            this.attivitaCoerente === ""
          ) {
            flagError = true;
          }
          if (!flagError) {
            if (this.attivitaCoerente === "1") {
              coerenza = true;
            }

            var infoReport: ReportVisiteInfo = {
              idReport: 0,
              idRichiesta: this.idRichiesta,
              denominazioneAzienda: this.denominazioneAzienda,
              tirocinante: this.tirocinante,
              tutorAziendale: this.tutorAziendale,
              tutorFormativo:
                tutorFormInfo.cognomeUtente + " " + tutorFormInfo.nomeUtente,
              dataInizio: this.dataInizio,
              // dataInizio: new Date(this.dataInizio)
              dataFine: this.dataFine,
              orarioInizioMattina: this.orarioInizioMattina,
              orarioFineMattina: this.orarioFineMattina,
              orarioInizioPomeriggio: this.orarioInizioPomeriggio,
              orarioFinePomeriggio: this.orarioFinePomeriggio,
              attivitaTirocinio: this.attivitaTirocinio,
              attivitaSvoltaTirocinante: this.attivitaSvoltaTirocinante,
              presenzaStagista: this.presenzaStagista,
              colloquioStagista: this.colloquioStagista,
              note: this.note,
              attivitaCoerente: coerenza,
              motivazioneNonCoerenza: this.motivazioneNonCoerenza,
              firmaTutorFormativo: signatureTutor.data,
              firmaTutorAziendale: "",
              dataVisita: this.dateTemp,
              oraVisita: this.oraVisita,
              personaleContattato: persContattatoString,
              tipoVisita: this.tipoVisita,
              attivita: this.activityType,
              dataReport: "",
              oraReport: "",
              idStatoAccettazione: 1
              // startDate: this.infoTirocinio.startDate,
              // finishDate: this.infoTirocinio.finishDate
            };
            // console.log(infoReport);
            // console.log(this.infoTirocinio)

            var payload = {
              emailAzienda: this.infoTirocinio.emailAzienda,
              emailTutor: this.infoTirocinio.emailTutor,
              tutorAziendale: infoReport.tutorAziendale,
              tirocinante: infoReport.tirocinante,
              dataVisita: infoReport.dataVisita,
              tutorFormativo:
                tutorFormInfo.cognomeUtente + " " + tutorFormInfo.nomeUtente,
              activityType: infoReport.attivita
            };

            user
              .dispatchCreateReportVisita(this["$store"], infoReport)
              .then(() => {
                user
                  .dispatchSendConfirmReport(this["$store"], payload)
                  .then(() => {
                    bus.$emit(
                      "successfullOperation",
                      "Report visita creato con successo"
                    );
                    this.close();
                    bus.$emit("loadReports");
                  })
                  .catch(error => {
                    if (error.response.status === 403) {
                      bus.$emit("errorOperation", error.response.statusText);
                      this["$router"].push("/login");
                    } else {
                      bus.$emit("errorOperation", error.response.statusText);
                    }
                  });
              })
              .catch(error => {
                if (error.response.status === 403) {
                  bus.$emit("errorOperation", error.response.statusText);
                  this["$router"].push("/login");
                } else {
                  bus.$emit("errorOperation", error.response.statusText);
                }
              });
          } else {
            bus.$emit(
              "errorOperation",
              "Assicurarsi di inserire tutti i campi del modulo"
            );
          }
        } else {
          bus.$emit("errorOperation", "Firma mancante");
        }
      }
    });
  }

  // created() {
  //   console.log(this.infoTirocinio);
  // }
}
